import { Buffer } from 'buffer';

import React from 'react';
import { Button, Tooltip } from 'react-bootstrap';
import { Download, FilePdf } from 'react-bootstrap-icons';
import { saveAs } from 'file-saver';
import mime from 'mime';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';

import { CreateUpdateAttachmentDto } from '../../../common/pokCore/autogenerated/pokApiClient';
import { usePokCore } from '../../../common/hooks/usePokCore';
import { useTranslation } from '../../../common/hooks/useTranslation';

interface AttachmentInputDownloadIconProps {
  attachment?: CreateUpdateAttachmentDto;
  isOpen?: boolean;
}

export const AttachmentInputDownloadIcon: React.FC<
  AttachmentInputDownloadIconProps
> = props => {
  const pok = usePokCore();
  const { t, tk } = useTranslation('commonLng');

  const loadFileContent = async (callback: (content: Blob) => void) => {
    if (props.attachment) {
      const localContent = props.attachment.fileContent;
      const bytes = localContent
        ? Buffer.from(localContent, 'base64')
        : (
            await pok.attachments.getFileByObjectIdAndObjectType(
              props.attachment.objectId,
              props.attachment.enObjectType,
            )
          )?.buffer;
      if (bytes && props.attachment.name) {
        const blob = new Blob([Buffer.from(bytes as ArrayBuffer)], {
          type: mime.getType(props.attachment.name) || undefined,
        });
        callback(blob);
      }
    }
  };

  const handleDownload = () =>
    loadFileContent((blob: Blob) => saveAs(blob, props.attachment?.name || ''));

  const handleOpen = () =>
    loadFileContent((blob: Blob) => window.open(URL.createObjectURL(blob)));

  if (props.isOpen) {
    return (
      // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
      <div onClick={e => e.stopPropagation()}>
        <OverlayTrigger
          overlay={<Tooltip>{t(tk.common.openNewWindow)}</Tooltip>}
        >
          <Button
            variant="outline-primary"
            onClick={handleOpen}
            disabled={!props.attachment}
          >
            <FilePdf />
          </Button>
        </OverlayTrigger>
      </div>
    );
  }

  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
    <div onClick={e => e.stopPropagation()}>
      <OverlayTrigger overlay={<Tooltip>{t(tk.button.download)}</Tooltip>}>
        <Button
          variant="outline-primary"
          onClick={handleDownload}
          disabled={!props.attachment}
        >
          <Download />
        </Button>
      </OverlayTrigger>
    </div>
  );
};
